// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  clients: [
    {
      url: 'valeria.fractalstay.com',
      kcUrl: 'https://auth.fractalite.com/auth',
      LinkCRM: 'https://crm.valeriahotels.com/',
      api: 'https://pmsvaleriaapi.fractalstay.com/api',
      kc: 'prod-pms',
      realm: 'master',
      crmTest:'https://crmapi.valeriahotels.com/api',

    
    },
    {
      url: 'fractal-pms-test.fractalite.com',
      kcUrl: 'https://auth.fractalite.com/auth',
      api: 'http://pmsapi.fractalite.com/api',
      LinkCRM: 'http://fractal-sales.com/',
      kc: 'test-pms',
      realm: 'master',
      crmTest:'http://crm-valeria-test.fractalite.com/api',
    
    },
    {
      url: 'localhost',
      api: 'https://pmsvaleriaapi.fractalstay.com/api',
      // api: 'http://pmsapi.fractalite.com/api',
      LinkCRM: 'http://fractal-sales.com/',
      apiCheckinData:'https://crmapi.valeriahotels.com/api',
      logo: 'fractalite',
      header: 'fractalite',
      kcUrl: 'https://auth.fractalite.com/auth',
      kc: 'test-pms',
      realm: 'master',
      crmTest:'https://crmapi.valeriahotels.com/api',
      urlcrm:'http://crm.sotlamer.travel',
      urlbookbeds:'http://beds.fractalite.com/#/properties/147/',
      urlAPIBookbeds:'https://beds-api.fractalite.com/properties/147/units',
      footer:{
        title:'------',
        website:'------',
        address:'------',
        email:'------'
      }
    },
    // {
    //   url: '10.15.189.201',
    //   api: 'http://pmsvaleriaapi.fractalstay.com/api',
    //   // api: 'http://pmsapi.fractalite.com/api',
    //   LinkCRM: 'http://fractal-sales.com/',
    //   apiCheckinData:'http://crm.sotlamer.travel/api',
    //   logo: 'fractalite',
    //   header: 'fractalite',
    //   kcUrl: 'https://auth.fractalite.com/auth',
    //   kc: 'test-pms',
    //   realm: 'master',
    //   crmTest:'https://crmapi.valeriahotels.com/api',
    //   urlcrm:'http://crm.sotlamer.travel',
    //   urlbookbeds:'http://beds.fractalite.com/#/properties/147/',
    //   urlAPIBookbeds:'https://beds-api.fractalite.com/properties/147/units',
    //   footer:{
    //     title:'------',
    //     website:'------',
    //     address:'------',
    //     email:'------'
    //   }
    // },

  ],
  url: '',
  // api: 'http://pmsapi.fractalite.com/api',
  // LinkCRM: 'http://fractal-sales.com/', 
  LinkCRM: 'https://crm.valeriahotels.com/',
  CRM: 'http://crmapi.valeriahotels.com',

  api: 'https://pmsvaleriaapi.fractalstay.com/api',
  // crmTest:'http://crm-valeria-test.fractalite.com/api',
  crmTest:'https://crmapi.valeriahotels.com/api',
  discountUrl:'https://crmapi.valeriahotels.com/api/allorders/discount/v2?',
  apiCheckinData:'',
  logo: '',
  header: '',
  devise: '',
  kcUrl: '',
  kc: '',
  realm: '',
  urlcrm:'',
  urlbookbeds:'',
  bedspropertiesApi : 'https://beds-api.fractalite.com/properties',
  urlAPIBookbeds:'',
  footer:{
    title:'',
    website:'',
    address:'',
    email:''
  },
  codeTel: {
    value: '',
    code: ''
  },
  supaBaseConfig: {
    supabaseUrl: 'https://tyxorufhlhymjuhxpuki.supabase.co',
    supabaseAnonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR5eG9ydWZobGh5bWp1aHhwdWtpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjM2ODQzODcsImV4cCI6MjA3OTI2MDM4N30.c0SSbM-nx3t-kD_mjcoDIc2VsVreSINAroxMfUajJa4',
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
